/**
 * Texto de interface do `web-cliente` — DESIGN_SYSTEM §9.5.
 *
 * > "Todo texto de interface fica em `packages/ui/content/*.pt-BR.json`, com chaves semanticas.
 * > Texto em JSX e erro de lint."
 *
 * ## DUVIDA
 *
 * O §9.5 nomeia `packages/ui/content/`. Mas o dicionario que vive la e o dos **componentes** do
 * design system (`preco.*`, `card.*`, `campo.*`), consumido pelo `t()` do `@farmacia/ui`, cujo
 * tipo `ChaveDeTexto` deriva daquele JSON. Colocar `checkout.confirmar` la faria o pacote de
 * design system conhecer o fluxo de compra do app — o que o proprio `@farmacia/ui` recusa no
 * cabecalho do seu `index.ts`: *"nao conhece rotas"*.
 *
 * Adotado: **chave de COMPONENTE em `@farmacia/ui`; chave de TELA aqui**, com a mesma forma
 * (JSON + funcao de acesso + tipo derivado do JSON, entao chave errada nao compila). O
 * `web-interno` tera o seu. Se o documento quiser um dicionario unico, a mudanca e mover este
 * arquivo: os prefixos ja sao disjuntos e nao colidem.
 */

import textos from './app.pt-BR.json';

/** As chaves existentes, derivadas do proprio JSON: chave errada nao compila. */
export type ChaveDeTextoDoApp = Exclude<keyof typeof textos, '$comentario'>;

const DICIONARIO: Readonly<Record<string, string>> = textos;

/** Interpola `{parametro}`. Sem biblioteca de template: e tudo de que o MVP precisa (§10.7). */
export function texto(
  chave: ChaveDeTextoDoApp,
  parametros: Readonly<Record<string, string | number>> = {},
): string {
  const bruto = DICIONARIO[chave];
  if (bruto === undefined) {
    throw new Error(`Chave de texto inexistente: ${chave} (DESIGN_SYSTEM §9.5).`);
  }
  return bruto.replace(/\{(\w+)\}/g, (inteiro, nome: string) => {
    const valor = parametros[nome];
    return valor === undefined ? inteiro : String(valor);
  });
}

export function chavesDoApp(): readonly string[] {
  return Object.keys(DICIONARIO).filter((chave) => chave !== '$comentario');
}
